import { Directive, OnInit, HostListener, Input, Renderer2, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const FLAG_CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FlagCheckboxDirective),  // tslint:disable-line: no-forward-ref
  multi: true
};

@Directive({
  selector: 'input[type=checkbox][appFlagCheckbox][ngModel]',
  providers: [FLAG_CHECKBOX_VALUE_ACCESSOR]
})
export class FlagCheckboxDirective implements ControlValueAccessor, OnInit {

  _onChange: (_: any) => void = () => {};
  _onTouched: () => void = () => {};
  @Input() value: string;
  @Input() mask: number;
  model: number;

  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    if (!this.mask) {
      throw new Error('Attribute \'mask\' is required');
    }
  }

  @HostListener('change', ['$event'])
  onChange(event) {
    let checked = event.target.checked;

    if (checked) {
      this.model |= this.mask; // set masked bit(s)
    } else if (checked === false) {
      this.model &= ~this.mask; // clear masked bit(s)
    }

    this._onChange(this.model);
  }

  @HostListener('blur')
  onTouched() {
    this._onTouched();
  }

  writeValue(value: any): void {
    let checked = (value & this.mask) === this.mask; // check masked bit(s)
    this.model = value;
    this._renderer.setProperty(this._elementRef.nativeElement, 'checked', checked);
  }

  registerOnChange(fn: () => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/flag-checkbox.directive.ts